module.exports = __webpack_public_path__ + "static/media/Carousels-FNB-Mobile.6f6165f9.jpg";